import React from 'react'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import LuxPlusPriceStack from 'luxPlus/components/LuxPlusPriceStack'
import { useOfferPriceWithMember } from 'hooks/Offers/useOfferPrice'

interface Props {
  captionText: string;
  memberPrice: number;
  price: number;
  value: number;
  duration: number;
  offer: App.BedbankOffer | App.Offer | App.OfferSummary
  showValueDiscount: boolean;
  discount?: number;
  saleUnit?: string;
}

function BaseOfferPriceContent({ captionText, memberPrice, price, value, duration, saleUnit, showValueDiscount, discount, offer }: Props) {
  const {
    saleUnit: displaySaleUnit,
    total: displayPrice,
    memberTotal: displayMemberPrice,
    value: displayValue,
  } = useOfferPriceWithMember({
    value,
    saleUnit: saleUnit ?? 'total',
    duration,
    total: price,
    memberTotal: memberPrice,
  })
  return (
    <>
      <PriceRowPriceCaption>{captionText}</PriceRowPriceCaption>
      <LuxPlusPriceStack
        price={displayPrice}
        memberPrice={displayMemberPrice}
        size="S"
        saleUnit={displaySaleUnit}
        offerConfig={offer.luxPlus}
      />
      {showValueDiscount && <PriceRowValueDiscountWithCaption
        size="M"
        originalValue={displayValue}
        discountPercentage={discount}
      />}
    </>
  )
}

export default BaseOfferPriceContent
